document.addEventListener('DOMContentLoaded', function() {
  const tabs = document.querySelectorAll('.keyingre-tabname');
  const textWrappers = document.querySelectorAll('.keying-txt-wrapper');
  const images = document.querySelectorAll('.keying-img');

  tabs.forEach(function(tab) {
    tab.addEventListener('click', function() {
      tabs.forEach(function(otherTab) {
        otherTab.classList.remove('active');
      });
      this.classList.add('active');
      const tabId = this.getAttribute('data-tab');

      textWrappers.forEach(function(wrapper) {
        wrapper.classList.remove('active');
      });
      const activeTextWrapper = document.querySelector(`.keying-txt-wrapper#${tabId}`);
      if (activeTextWrapper) {
        activeTextWrapper.classList.add('active');
      }

      images.forEach(function(image) {
        image.classList.remove('active');
      });
      const activeImage = document.querySelector(`.keying-img[data-tab="${tabId}"]`);
      if (activeImage) {
        activeImage.classList.add('active');
      }
    });
  });

  const tabNamesWrapper = document.querySelector('.keyingre-tabnames-wrapper');

  let isDown = false;
  let startX;
  let scrollLeft;

  tabNamesWrapper.addEventListener('mousedown', function(e) {
    isDown = true;
    tabNamesWrapper.classList.add('dragging');
    startX = e.pageX - tabNamesWrapper.offsetLeft;
    scrollLeft = tabNamesWrapper.scrollLeft;
    e.preventDefault(); 
  });

  tabNamesWrapper.addEventListener('mouseleave', function() {
    isDown = false;
    tabNamesWrapper.classList.remove('dragging');
  });

  tabNamesWrapper.addEventListener('mouseup', function() {
    isDown = false;
    tabNamesWrapper.classList.remove('dragging');
  });

  tabNamesWrapper.addEventListener('mousemove', function(e) {
    if (!isDown) return;
    e.preventDefault();
    const x = e.pageX - tabNamesWrapper.offsetLeft;
    const walk = (x - startX) * 1; 
    tabNamesWrapper.scrollLeft = scrollLeft - walk;
  });
});
